/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentPeopleQueryResponse,
  GetApiV1IndividualpaymentPeopleQueryParams,
  GetApiV1IndividualpaymentPeople401,
  GetApiV1IndividualpaymentPeople500,
} from "../../types/individualPaymentController/GetApiV1IndividualpaymentPeople.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentPeople } from "../../clients/individualPaymentController/getApiV1IndividualpaymentPeople.ts";

export const getApiV1IndividualpaymentPeopleQueryKey = (
  params?: GetApiV1IndividualpaymentPeopleQueryParams,
) =>
  [
    { url: "/api/v1/individualpayment/people" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1IndividualpaymentPeopleQueryKey = ReturnType<
  typeof getApiV1IndividualpaymentPeopleQueryKey
>;

export function getApiV1IndividualpaymentPeopleQueryOptions(
  params?: GetApiV1IndividualpaymentPeopleQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1IndividualpaymentPeopleQueryKey(params);
  return queryOptions<
    GetApiV1IndividualpaymentPeopleQueryResponse,
    ResponseErrorConfig<
      GetApiV1IndividualpaymentPeople401 | GetApiV1IndividualpaymentPeople500
    >,
    GetApiV1IndividualpaymentPeopleQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentPeople(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna pessoas com matrícula, filtradas por ids de pessoa, nome, e-mail, RA, CPF, CPF/CNPJ de terceiro, nosso número, nota fiscal, turma, empresa e método de pagamento (grupo boleto ou cartão). A empresa do usuário autenticado sobrepõe o parâmetro 'companyId'. Migrado do legado IndividualPayment/LoadGridDataAsyncPeople. **(Requer Authorization para autenticação)**
 * @summary Retorna a lista paginada de pessoas da tela de pagamento individual (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/people}
 */
export function useGetApiV1IndividualpaymentPeople<
  TData = GetApiV1IndividualpaymentPeopleQueryResponse,
  TQueryData = GetApiV1IndividualpaymentPeopleQueryResponse,
  TQueryKey extends QueryKey = GetApiV1IndividualpaymentPeopleQueryKey,
>(
  params?: GetApiV1IndividualpaymentPeopleQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentPeopleQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentPeople401
          | GetApiV1IndividualpaymentPeople500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentPeopleQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentPeopleQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1IndividualpaymentPeople401 | GetApiV1IndividualpaymentPeople500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
